'use client';

import { c as _c } from "react/compiler-runtime";
import { useToast } from '@common/hooks';
import { ADISON_OFFERWALL_LIST_TITLE } from '@/constants/offerwall';
import { useAdUserId } from '@/hooks/useAdUserId';
import { useVerificationCheck } from '@/hooks/useVerificationCheck';
import { useOpenAdpopcornOfferwall } from '@/modules/adpopcorn';
import { MESSAGE_KEYWORD, useHandleApp } from '@/modules/wello-app';
import { useAuthStore } from '@/stores/AuthStore';
import { useDeviceInfoStore } from '@/stores/DeviceStore';
import { resolveOfferwallVendor } from '../_utils/resolveOfferwallVendor';
import { useBenefitGate } from './useBenefitGate';

/**
 * 오퍼월 지면 열기. 게이트(앱·로그인·혜택동의) → 본인인증 확인 → OS별 벤더 해석 순으로 태운다.
 * 퀵액션 타일과 혜택 메뉴 목록이 공유하며, 소비처가 gateModals를 함께 렌더한다.
 */
export const useOpenOfferwall = () => {
  const $ = _c(19);
  const {
    triggerGate,
    gateModals
  } = useBenefitGate();
  const {
    adUserId,
    isPending: isAdUserIdPending
  } = useAdUserId();
  const appVersion = useDeviceInfoStore(_temp);
  const {
    toast
  } = useToast();
  const isLogin = useAuthStore(_temp2);
  let t0;
  if ($[0] !== isLogin) {
    t0 = {
      enabled: isLogin
    };
    $[0] = isLogin;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    checkVerification,
    redirectToVerification,
    isLoading: isVerificationLoading
  } = useVerificationCheck(t0);
  const {
    open: openAdpopcorn
  } = useOpenAdpopcornOfferwall();
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      type: MESSAGE_KEYWORD.OPEN_ADISON_OFFERWALL
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    request: requestAdison
  } = useHandleApp(t1);
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      type: MESSAGE_KEYWORD.OPEN_PINCRUX_OFFERWALL
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    request: requestPincrux
  } = useHandleApp(t2);
  let t3;
  if ($[4] !== adUserId || $[5] !== appVersion || $[6] !== checkVerification || $[7] !== isAdUserIdPending || $[8] !== isVerificationLoading || $[9] !== openAdpopcorn || $[10] !== redirectToVerification || $[11] !== requestAdison || $[12] !== requestPincrux || $[13] !== toast || $[14] !== triggerGate) {
    t3 = placementKey => {
      triggerGate(["app", "login", "consent"], () => {
        if (isVerificationLoading || isAdUserIdPending) {
          toast({
            message: "\uD68C\uC6D0 \uC815\uBCF4\uB97C \uD655\uC778\uD558\uACE0 \uC788\uC5B4\uC694. \uC7A0\uC2DC \uD6C4 \uB2E4\uC2DC \uB20C\uB7EC \uC8FC\uC138\uC694",
            type: "info"
          });
          return;
        }
        if (checkVerification()) {
          return;
        }
        if (!adUserId) {
          redirectToVerification();
          return;
        }
        const resolved = resolveOfferwallVendor(placementKey, appVersion);
        if (!resolved) {
          toast({
            message: "\uC9C0\uAE08\uC740 \uCC38\uC5EC\uD560 \uC218 \uC5C6\uB294 \uBBF8\uC158\uC774\uC5D0\uC694",
            type: "fail"
          });
          return;
        }
        if (resolved.vendor === "adison") {
          requestAdison({
            uid: adUserId,
            offerwallListTitle: ADISON_OFFERWALL_LIST_TITLE
          });
          return;
        }
        if (resolved.vendor === "pincrux") {
          requestPincrux({
            usrkey: adUserId
          });
          return;
        }
        openAdpopcorn(adUserId);
      });
    };
    $[4] = adUserId;
    $[5] = appVersion;
    $[6] = checkVerification;
    $[7] = isAdUserIdPending;
    $[8] = isVerificationLoading;
    $[9] = openAdpopcorn;
    $[10] = redirectToVerification;
    $[11] = requestAdison;
    $[12] = requestPincrux;
    $[13] = toast;
    $[14] = triggerGate;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  const openOfferwall = t3;
  let t4;
  if ($[16] !== gateModals || $[17] !== openOfferwall) {
    t4 = {
      openOfferwall,
      gateModals
    };
    $[16] = gateModals;
    $[17] = openOfferwall;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  return t4;
};
function _temp(state) {
  return state.appVersion;
}
function _temp2(state_0) {
  return state_0.isLogin === true;
}